import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = {
  key: 0,
  class: "fluid grid"
}
const _hoisted_5 = { class: "field col-12 md:col-4" }
const _hoisted_6 = { class: "field col-12 md:col-4" }
const _hoisted_7 = { class: "field col-12 md:col-4" }
const _hoisted_8 = { class: "field col-12 md:col-2" }
const _hoisted_9 = { class: "field col-12 md:col-3" }
const _hoisted_10 = { class: "field col-12 md:col-3" }
const _hoisted_11 = { class: "field col-12 md:col-4" }
const _hoisted_12 = { class: "field col-12 md:col-6" }
const _hoisted_13 = { class: "field col-12 md:col-6" }
const _hoisted_14 = { class: "field col-12 md:col-12" }
const _hoisted_15 = { class: "field col-12 md:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-10" }, [
        _createElementVNode("h4", null, "Evacuation Details")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.showDetails,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDetails) = $event)),
          style: {"float":"right"},
          onChange: _ctx.onToggleDetails
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    (_ctx.visibleDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Fire evacuation service type", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedEvacuationData.fireEvacuationServiceType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.receivedEvacuationData.fireEvacuationServiceType) = $event)),
              options: _ctx.fireEvacuationServiceOptions,
              optionValue: "value",
              optionLabel: "label"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Fire evacuation manual last updated", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.receivedEvacuationData.fireEvacuationManualLastUpdated,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.receivedEvacuationData.fireEvacuationManualLastUpdated) = $event)),
              dateFormat: "d M yy",
              showIcon: true,
              showButtonBar: true,
              class: "w-100pc"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[17] || (_cache[17] = _createElementVNode("label", null, "Warden training", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedEvacuationData.wardenTraining,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receivedEvacuationData.wardenTraining) = $event)),
              options: _ctx.wardenTrainingOptions,
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "NZFS approval required", -1)),
            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.receivedEvacuationData.nzfsApprovalRequired,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receivedEvacuationData.nzfsApprovalRequired) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[21] || (_cache[21] = _createElementVNode("label", null, "NZFS approval date", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.receivedEvacuationData.nzfsApproval,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receivedEvacuationData.nzfsApproval) = $event)),
              dateFormat: "d M yy",
              showIcon: true,
              showButtonBar: true,
              class: "w-100pc"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "NZFS application date", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.receivedEvacuationData.nzfApplicationDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.receivedEvacuationData.nzfApplicationDate) = $event)),
              dateFormat: "d M yy",
              showIcon: true,
              showButtonBar: true,
              class: "w-100pc"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[25] || (_cache[25] = _createElementVNode("label", null, "Scheme reference", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedEvacuationData.schemeReference,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.receivedEvacuationData.schemeReference) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[26] || (_cache[26] = _createElementVNode("label", null, "Fire alarm type", -1)),
            _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
            _createVNode(_component_Dropdown, {
              class: "flex",
              modelValue: _ctx.receivedEvacuationData.fireAlarmType,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.receivedEvacuationData.fireAlarmType) = $event)),
              options: _ctx.fireAlarmOptions,
              optionLabel: "label",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[28] || (_cache[28] = _createElementVNode("label", null, "Security alarm type", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedEvacuationData.securityAlarmType,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receivedEvacuationData.securityAlarmType) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[29] || (_cache[29] = _createElementVNode("label", null, "Fire alarm panel located", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedEvacuationData.fireAlarmPanelLocated,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.receivedEvacuationData.fireAlarmPanelLocated) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Fire alarm monitored by", -1)),
            _createVNode(_component_InputText, {
              modelValue: _ctx.receivedEvacuationData.fireAlarmMonitoredBy,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receivedEvacuationData.fireAlarmMonitoredBy) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}